// extracted by mini-css-extract-plugin
export default {"text":"Errors_text__W0jTS","title":"Errors_title__gb0mh","subtitle":"Errors_subtitle__8jQC3","content":"Errors_content__KYw92","image":"Errors_image__u+tUb"};